import { Vehicle } from 'core/types/vehicle';

import usePaginationHandler from './usePaginationHandler';

export default function useCustomerVehicles(customerId: number) {
  return usePaginationHandler<Vehicle>(customerId === undefined ? undefined : `customers/${customerId}/vehicles`);
}
